var map = {
	"./1.png": 6634,
	"./10.png": 9504,
	"./2.png": 7217,
	"./3.png": 9736,
	"./4.png": 8727,
	"./5.png": 3150,
	"./6.png": 3509,
	"./7.png": 620,
	"./8.png": 107,
	"./9.png": 8978,
	"./AR_AboutUs.png": 1364,
	"./AR_News.png": 3626,
	"./AR_Stroeis.png": 6310,
	"./EN_Aboutus.png": 8868,
	"./EN_Stories.png": 532,
	"./EN_news.png": 1322,
	"./Footer_White.png": 8416,
	"./Vector.png": 2702,
	"./Vector2.png": 6254,
	"./Vector3.png": 8743,
	"./Vector4.png": 9128,
	"./Vector5.png": 9345,
	"./detailsimg.png": 6332,
	"./donationTestImage.png": 5890,
	"./footerLogo.png": 4087,
	"./google_map.png": 6345,
	"./light-logo.png": 5751,
	"./logo.png": 2806,
	"./logoNew.png": 2870,
	"./mosque.png": 6001,
	"./new.png": 305,
	"./news1.png": 6725,
	"./news2.png": 5726,
	"./news3.png": 7687
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4504;